import { Button, Typography } from "@fanka/ui-admin";
import { useLocalViewsStore } from "@on-site/features/top/hooks/useLocalViewsStore";
import { useTimeout } from "@on-site/hooks/useTimeout";
import { PageLayout } from "@on-site/layouts/PageLayout";

export const InvalidPage = () => {
  const { resetView } = useLocalViewsStore();

  useTimeout(() => resetView(), 1000 * 30);

  return (
    <PageLayout>
      <div className="mx-auto flex h-full w-full max-w-[424px] flex-col items-center justify-center gap-y-12">
        <Typography.Heading type="h1">お客様の情報が見つかりませんでした</Typography.Heading>
        <ul className="text-ui-500 flex list-outside flex-col gap-y-4">
          <li>
            <Typography.UiText size="lg">
              以下を確認の上、再度お試しください。うまくいかない場合は、受付へお知らせください。
            </Typography.UiText>
          </li>
          <li className="ml-4 list-disc">予約詳細ページで診察券コードをご確認ください</li>
          <li className="ml-4 list-disc">ご登録のメールアドレスまたはLINEでお送りした診察券コードをご確認ください</li>
        </ul>
        <Button size="lg" block onClick={resetView}>
          最初の画面へ
        </Button>
      </div>
    </PageLayout>
  );
};
